<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="ep">“… And when the angels</p>
<p class="ep">ask me to recall … I’ll tell them</p>
<p class="ep">I remember you…”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?36f90cb0